/*
 * @Author: Yun
 * @Date: 2023-11-29 15:52:26
 * @Last Modified by: Yun
 * @Last Modified time: 2023-12-29 17:02:18
 */
import React, { useState, useEffect, useRef, useImperativeHandle } from 'react'
import { CSSTransition } from 'react-transition-group'
import firstLogo from '@icons/cgtn.jpg'
import gsap from 'gsap'
import { Button } from 'cgtd'
import firstTitle from '@images/firstPage/title.jpg'
import share from '@icons/share.png'
import fb from '@images/footer/fb.png'
import x from '@images/footer/x.png'
import wb from '@images/footer/wb.png'
import $ from 'jquery'
import './index.less'

const NewDemo = (props) => {
    const [position, setPosition] = useState(0)
    const [showShare, setShowShare] = useState(0)

    const handleShare = () => {
        setShowShare(showShare == 1 ? 0 : 1)
    }
    useEffect(() => {
        // moveDiv()
        demoTimeline()
    }, [])

    const demoTimeline = () => {
        let tl = gsap.timeline({
            // yes, we can add it to an entire timeline!
            scrollTrigger: {
                trigger: '.newdemo-wrapper-mobile',
                pin: '.newdemo-wrapper-mobile', // pin the trigger element while active
                // pinSpacing: false,
                start: 'top top', // when the top of the trigger hits the top of the viewport
                end: '+=500', // end after scrolling 500px beyond the start
                scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
                pinType: 'fixed',
                snap: {
                    snapTo: 'labels', // snap to the closest label in the timeline
                    duration: { min: 0.2, max: 3 }, // the snap animation should be at least 0.2 seconds, but no more than 3 seconds (determined by velocity)
                    delay: 0.2, // wait 0.2 seconds from the last scroll event before doing the snapping
                },
            },
        })

        tl.addLabel('start')
            // add animations and labels to the timeline
            .to(`.title`, { duration: 0.2, opacity: 0 })
            // .to('.city-wrapper', { duration: 0.2, opacity: 0 })
            // .to('.character', { duration: 0.2, opacity: 1 })
            .to('.content-wrapper', { duration: 0.2, opacity: 0.99 })
        tl.addLabel('end')
    }
    const moveDiv = () => {
        setPosition(Math.min(position + 5000, 5000))
    }
    return (
        <div className="newdemo-wrapper-mobile">
            <a target="_blank" href="https://www.cgtn.com/">
                <div className="logo"></div>
            </a>
            <div className={`share`}>
                <img className={`share-icon`} src={share} alt="" onClick={handleShare} />
                <div
                    className={`share-content`}
                    id={`share-content`}
                    style={{ opacity: showShare }}
                >
                    <a
                        className={`share-content-icon`}
                        target="_blank"
                        href="https://www.facebook.com/sharer/sharer.php?u=https://news.cgtn.com/event/2024/China2024/index.html"
                        rel="noreferrer"
                    >
                        <img src={fb} alt="" />
                    </a>
                    <a
                        className={`share-content-icon`}
                        target="_blank"
                        href="https://twitter.com/intent/tweet?text=Chinese Modernization, People's Well-being Matters Most&url=https://news.cgtn.com/event/2024/China2024/index.html"
                        rel="noreferrer"
                    >
                        <img src={x} alt="" />
                    </a>
                    <a
                        className={`share-content-icon`}
                        target="_blank"
                        href="http://service.weibo.com/share/share.php?appkey=4122844478&title=Chinese Modernization, People's Well-being Matters Most&url=https://news.cgtn.com/event/2024/China2024/index.html"
                        rel="noreferrer"
                    >
                        <img src={wb} alt="" />
                    </a>
                </div>
            </div>
            <div className="title"></div>
            <div className="city-wrapper" id="city">
                <div className="city-pt1"></div>
                <div className="city-pt2"></div>
            </div>
            {/* <div className="character" id="No1"></div> */}

            <div className="content-wrapper">
                <div className="content">
                    <div className="content-main">
                        "As far as Chinese modernization is concerned, the people's well-being
                        matters the most."
                        <br />
                        <div style={{ textAlign: 'end', marginTop: '0.8vw', marginRight: '1vw' }}>
                            --Xi Jinping
                        </div>
                    </div>
                </div>
            </div>
            <div
                className="train"
                style={{
                    transform: `translateX(${position}px)`,
                    transition: 'transform 2s ease-in-out',
                }}
            ></div>
        </div>
    )
}

export default NewDemo
